import { Component, OnInit } from '@angular/core';
import { NgbDate, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { PreviewComponent } from '../pop-ups/preview/preview.component';
import { catchError } from 'rxjs';
import { CompaniesService } from '../../companies/companies.service';
import { AppPreviewComponent } from '../pop-ups/app-preview/app-preview.component';
import { AddCertificationsComponent } from '../certifications/popups/add-certifications/add-certifications.component';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import { CodeCrosswalkService } from 'src/app/components/admin/code-crosswalk/code-crosswalk.service';
import { Id } from 'src/app/components/admin/code-crosswalk/pages/code-crosswalk.model';
import { AddEditCodeGroupComponent } from 'src/app/components/admin/code-crosswalk/pop-ups/add-edit-code-group/add-edit-code-group.component';
import { AgGridService } from 'src/app/shared/components/ag-grid/ag-grid.service';
import { DownloadDocuments } from '../../companies/companies.model';
import { DocumentTypes, PopUpTitles, TabNames } from 'src/app/shared/model/enum';
import { Menu } from 'src/app/shared/services/nav.service';
import { TabsService } from 'src/app/shared/components/tabs/tabs.service';
import { Router } from '@angular/router';
import { CommonModelPopUpComponent } from 'src/app/shared/components/common-model-pop-up/common-model-pop-up.component';
import { StingToDateService } from 'src/app/shared/services/stringToDate.service';
import { TraceDocument, TraceLabel } from 'src/app/shared/model/enum';

const OFFER_SCORE_CONFIG = {
  label: {
    [TraceLabel.FullManufacturerLabel]: 30,
    [TraceLabel.RedactedManufacturerLabel]: 10,
    [TraceLabel.NoManufacturerLabel]: 0,
  } as Record<string, number>,

  traceDocument: {
    [TraceDocument.ManufacturerCoc]: 40,
    [TraceDocument.FranchiseCoc]: 40,
    [TraceDocument.ThirdPartyFranchise]: 10,
  } as Record<string, number>,

  traceablePart: { yes: 30, no: 0 },
  recentTestReport: { yes: 10, no: 0 },
  avlVendorBonus: 30,
  maxScore: 140,
} as const;

@Component({
  selector: 'app-document-cell-renderer',
  templateUrl: './document-cell-renderer.component.html',
  styleUrls: ['./document-cell-renderer.component.scss']
})
export class DocumentCellRendererComponent implements OnInit, ICellRendererAngularComp {
  params:any;
  cellRendererParams:any;
  header = ''
  base64String;
  inputValue:string;
  tooltipContent: string = '';
  offcanvasActive = false;
  isAddValue:boolean = true;
  dateRendererValue;
  downloadDocuments= new DownloadDocuments();
  selectedDropdownValues:boolean= false;
  enumPopUpTitles        = PopUpTitles;
  ResMsgFromCompanyOrContact: string;
  tabName = TabNames;

  constructor(public modalService:NgbModal,
    public companiesService:CompaniesService,
    private toastr: ToastrService,
    public codeCrosswalkService:CodeCrosswalkService,
    public agGridService:AgGridService,
    private tabsService: TabsService, private router: Router, 
    public stringToDateService: StingToDateService,


    ) { }
  agInit(params: ICellRendererParams<any, any>): void {
    this.header = params.colDef.field;
    this.selectedDropdownValues = params?.data?.status??false;
    this.cellRendererParams = params.colDef.cellRendererParams;
    this.params = params
    const result = this.recalculateScore(this.params?.data);
    this.inputValue = this.params?.data?.offerScore && this.params?.data?.offerScore !== 'NA' && this.params?.data?.offerScore !== '' 
        ? this.params?.data?.offerScore 
        : `${result.score}/${result.maxScore}`;
    this.tooltipContent = this.buildTooltip(result.breakdown);
    if(params.data.expirationDate){
      this.dateRenderer(params.data.expirationDate);
    }
  } 

  private recalculateScore(data: any): any {
    if (!data) return { score: 0, maxScore: OFFER_SCORE_CONFIG.maxScore, breakdown: null };
    const trace = data?.traceDetails || data || {};
    const breakdown = {
      label: this.getLabelScore(trace.labelId),
      traceDocument: this.getTraceDocScore(trace.traceDocument),
      traceablePart: trace.isTraceableLabel ? OFFER_SCORE_CONFIG.traceablePart.yes : 0,
      recentTestReport: trace.isRecentTraceReport ? OFFER_SCORE_CONFIG.recentTestReport.yes : 0,
      avlVendor: data?.isAvlVendor ? OFFER_SCORE_CONFIG.avlVendorBonus : 0,
    };
    const score = Object.values(breakdown).reduce((sum, v) => sum + (typeof v === 'number' ? v : 0), 0);
    return {
      score,
      maxScore: OFFER_SCORE_CONFIG.maxScore,
      breakdown
    };
  }
  private getLabelScore(labelId: string | null | undefined): number {
    if (!labelId) return 0;
    return OFFER_SCORE_CONFIG.label[labelId] ?? 0;
  }
  private getTraceDocScore(traceDoc: string | null | undefined): number {
    if (!traceDoc) return 0;
    return OFFER_SCORE_CONFIG.traceDocument[traceDoc] ?? 0;
  }
  private buildTooltip(breakdown: any): string {
    if (!breakdown) {
      return [
        `Label: 0`,
        `Trace Doc: 0`,
        `Traceable Part: 0`,
        `Test Report: 0`,
        `AVL Vendor (Bonus): 0`,
        `Testing: Optional`,
      ].join('\n');
    }
    return [
      `Label: ${breakdown?.label ?? 0}`,
      `Trace Doc: ${breakdown?.traceDocument ?? 0}`,
      `Traceable Part: ${breakdown?.traceablePart ?? 0}`,
      `Test Report: ${breakdown?.recentTestReport ?? 0}`,
      `AVL Vendor (Bonus): ${breakdown?.avlVendor ?? 0}`,
      `Testing: Optional`,
    ].join('\n');
  }

  refresh(params: ICellRendererParams<any, any>): boolean {
    return false
  }

  ngOnInit(): void {
    this.importCompanies();
  }
  change(){
    switch (this.params.data.type) {
      case '.jpg':
      case '.png':
      case '.jpeg':
      case '.webp':
      case '.gif':
      case '.svg':
        this.previewImage();
      break;
      case '.pdf':
      //  this.previewData();
      this.previewPdfData();
      break;
      default:
        this.preview();
    }
  }
  previewImage() {
    const data = this.params.data;
     if(data.certificationId){
      this.downloadDocuments.guid=data.guId;
      this.downloadDocuments.documentTypeId=DocumentTypes.certificationDocument;
      this.companiesService.downloadCertificationDocument(this.downloadDocuments).subscribe((res) => {
        if (res.isSuccess) {
          this.openImagePreview(res);
        }
      });
    }else if(this.params?.lineInformation){
      this.downloadDocuments.guid=data?.guId;
      this.downloadDocuments.documentTypeId=data?.documentTypeId;
      this.companiesService.downloadDocument(this.downloadDocuments).subscribe((res) => {
        if (res.isSuccess) {
          this.openImagePreview(res);
        }
      });
    }
    else{
      this.downloadDocuments.guid=data.guId;
      this.downloadDocuments.documentTypeId=DocumentTypes.companyDocuments;
      this.companiesService.downloadDocument(this.downloadDocuments).subscribe((res) => {
        if (res.isSuccess) {
          this.openImagePreview(res);
        }
      });

    }
  }
  openImagePreview(res){
    this.base64String = res.response.base64String;
    const fileUrl = `data:image/jpeg;base64,${this.base64String}`;
    if (fileUrl) {
      const newTab = window.open('', '_blank');
      if (newTab) {
        newTab.document.write('<html><head><title>Image Preview</title>');
        newTab.document.write('<style>body { display: flex; justify-content: center; align-items: center; height: 100vh; margin: 0;background: black; }</style>');
        newTab.document.write('</head><body>');
        newTab.document.write('<img src="' + fileUrl + '" style="max-width: 100%; max-height: 100%;">');
        newTab.document.write('</body></html>');
        newTab.document.close();
      }
    }
  }
    previewPdfData() {
    const data = this.params.data;
   if(data.certificationId){
    this.downloadDocuments.guid=data.guId;
    this.downloadDocuments.documentTypeId=DocumentTypes.certificationDocument;
      this.companiesService.downloadCertificationDocument(this.downloadDocuments).subscribe((res) => {
        if (res.isSuccess) {
          this.openPdfPreview(res);
        }
      });
    }else if(this.params?.lineInformation){
      this.downloadDocuments.guid=data?.guId;
      this.downloadDocuments.documentTypeId=data?.documentTypeId;
      this.companiesService.downloadDocument(this.downloadDocuments).subscribe((res) => {
        if (res.isSuccess) {
          this.openPdfPreview(res);
        }
      });
    }
    else{
      this.downloadDocuments.guid=data.guId;
      this.downloadDocuments.documentTypeId=DocumentTypes.companyDocuments;
      this.companiesService.downloadDocument(this.downloadDocuments).subscribe((res) => {
        if (res.isSuccess) {
          this.openPdfPreview(res);
        }
      });
    }
  }
  openPdfPreview(res: any) {
    const base64Data = res.response.base64String;
    const fileUrl = 'data:application/pdf;base64,' + base64Data;
    if (fileUrl) {
      const newTab = window.open('', '_blank');
      if (newTab) {
        newTab.document.write('<html><head><title>PDF Preview</title></head><body><embed src="' + fileUrl + '" type="application/pdf" width="100%" height="100%"></embed></body></html>');
        newTab.document.close();
      }
    }
  }
  
  previewData(){
    const modalRef = this.modalService.open(AppPreviewComponent, {
      centered: true,
      backdrop: "static",
       size: "lg",
     // windowClass: "modal-fullscreen",
    });
    this.companiesService.preview.next({guId:this.params.data.guId,name:'documentsTab'});
  }
  preview() {
    const modalRef = this.modalService.open(PreviewComponent, {
      centered: true,
      backdrop: "static",
      size: "sm",

    });
  this.companiesService.preview.next( {guId:this.params.data.guId,name:'documentsTab'});

  switch (this.params.data.type) {
    // case '.jpg':
    // case '.png':
    // case '.jpeg':
    //   modalRef.componentInstance.jpg = true;
    //   modalRef.componentInstance.isLoadings = true;
    //   this.companiesService.downloadDocument(this.params.data.guId).subscribe((res) => {
    //     if (res.isSuccess) {
    //        this.base64String = res.response.base64String;
    //        modalRef.componentInstance.isLoadings = false;
    //        modalRef.componentInstance.url = `data:image/jpeg;base64,${this.base64String}`;
    //     }
    //   });   
    //   break;
    case '.doc':
    case '.docx':
     modalRef.componentInstance.docx = true;
        break;
    case '.txt':
      modalRef.componentInstance.excel = true;
        break;
   case '.csv':
      modalRef.componentInstance.csv = true;
        break;
    //  case '.pdf':
    //    modalRef.componentInstance.pdf = true;
    //     break;
     case '.xlsx':
     case '.xls':
      modalRef.componentInstance.xlsx = true;
        break;
     default:
      modalRef.componentInstance.other  = 'Unsupported file type.';
  }
  }
  
download() {
  const data = this.params.data;
 if(data.certificationId){
    this.downloadDocuments.guid=data.guId;
    this.downloadDocuments.documentTypeId=DocumentTypes.certificationDocument;
    this.companiesService.downloadCertificationDocument(this.downloadDocuments).subscribe((res) => {
      if (res.isSuccess) {
        this.handleDownloadSuccess(res);
      }
    });
  }else if(this.params?.lineInformation){
    this.downloadDocuments.guid=data?.guId;
    this.downloadDocuments.documentTypeId=data?.documentTypeId;
    this.companiesService.downloadDocument(this.downloadDocuments).subscribe((res) => {
      if (res.isSuccess) {
        this.handleDownloadSuccess(res);
      }
    });
  }
  else{
    this.downloadDocuments.guid=data.guId;
    this.downloadDocuments.documentTypeId=DocumentTypes.companyDocuments;
    this.companiesService.downloadDocument(this.downloadDocuments).subscribe((res) => {
      if (res.isSuccess) {
        this.handleDownloadSuccess(res);
      }
    });
  }
}
handleDownloadSuccess(res){
  const base64Data = res.response.base64String;
  const byteCharacters = atob(base64Data);
  const byteArrays:any = [];

  for (let i = 0; i < byteCharacters.length; i++) {
    byteArrays.push(byteCharacters.charCodeAt(i));
  }

  const byteArray = new Uint8Array(byteArrays);
  const fileBlob = new Blob([byteArray], { type: 'application/octet-stream' });
  const url = URL.createObjectURL(fileBlob);
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.download = res.response.fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

}
    handleError(err: any) {
    throw new Error('Method not implemented.');
  }
  delete(){
    const Id =this.params.data.id;
    this.companiesService.deleteCertification(Id).subscribe((res)=>{
      if (res.isSuccess) {
        this.toastr.success(res.message);
        this.companiesService.isLoadData.next(true);
      }
      if (!res.isSuccess) {
        this.toastr.error(res.message);
      }
    })
  }

  edit(){
    const modalRef = this.modalService.open(AddCertificationsComponent, {
      centered: true,
      backdrop: "static",
      windowClass: "certificationClass",
    });
    modalRef.componentInstance.isAddValue = this.isAddValue;
    modalRef.componentInstance.certification.Id = this.params.data.certificationId;
    const dateString = this.params.data.dateIssued;
   const dateIssued = this.stringToDateService.convertStringToDate(dateString)
   modalRef.componentInstance.dateIssued = dateIssued;
    // const parsedDate = moment(dateString, 'MM/DD/YYYY');
    // const formattedDate = parsedDate.format('YYYY-MM-DD');
    // modalRef.componentInstance.selectedDate = formattedDate;
     const dateString1 = this.params.data.expirationDate;
     const dateExpired = this.stringToDateService.convertStringToDate(dateString1)
     modalRef.componentInstance.expirationDate = dateExpired;

    // const parsedDate1 = moment(dateString1, 'YYYY-MM-DDTHH:mm:ss');
    // const formattedDate1 = parsedDate1.format('YYYY-MM-DD');
    // modalRef.componentInstance.selectedDate1 = formattedDate1;
    modalRef.componentInstance.id = this.params.data.id;
    modalRef.componentInstance.fileName = this.params.data.fileName;
    modalRef.componentInstance.guId = this.params.data.guId;
    modalRef.componentInstance.type = this.params.data.type;
  }
  dateRenderer(params: any) {
    const originalDate = params;
    const dateObject = new Date(originalDate);
    const year = dateObject.getFullYear();
    const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
    const day = dateObject.getDate().toString().padStart(2, '0');
    const formattedDate = `${month}/${day}/${year}`;
    this.dateRendererValue = formattedDate;
    return formattedDate;
  }
  // for code-crosswalk page
  editCodeCrosswalk(){
    const customEvent = new CustomEvent('editIconClick', {
      detail : { data: this.params },
    });
    document.dispatchEvent(customEvent);
  }

  // for code-crosswalk page
importCompanies(){
  this.agGridService.importCompaniesValue.subscribe((res)=>{
    if(res !== undefined){
      const Id =this.params.data.system
   //   this.selectedDropdownValues = res;
    }
  });

}
openContactInfo(params){
  this.companiesService.id=params.data.companyId;
  let url = `crm/companies/company-info/${this.companiesService.id}`
  const item: Menu = { path: url, icon: '', title: params.data.companyName, type: 'link',id:params.data.companyId}
  this.tabsService.addTab(item);
  this.router.navigateByUrl(url);
  this.companiesService.activeTab.next(3);

}
deleteRow(params){
  params.node.setSelected(true);
  const selectedNode = params.api.getSelectedRows();
  // this.params.api.applyTransaction({ remove: selectedNode});
  const customEvent = new CustomEvent('deleteButtonClick', {
    detail : { data: this.params },
  });
  document.dispatchEvent(customEvent);
}
insertRow(params){
  if(params?.data?.qty){
  const customEvent = new CustomEvent('splitLineClick', {
    detail : { data: this.params },
  });
  document.dispatchEvent(customEvent);
}else
this.toastr.error('Please add quantity.')
}
insertImages(params){
  const customEvent = new CustomEvent('imageIconClick', {
    detail : { data: this.params },
  });
  document.dispatchEvent(customEvent);
}
onSerialNumber(params){
  if(params?.data?.partConsignmentId && params?.data?.serialNumberModel?.length === 0 && !params?.data?.partInventoryId ||
    params?.data?.partInventoryId && params?.data?.serialNumberModel?.length === 0 && !params?.data?.partConsignmentId
  ) return
  const customEvent = new CustomEvent('serialNumberClick', {
    detail : { data: this.params },
  });
  document.dispatchEvent(customEvent);
}
}
